export function removeLeadingZeros(num: any) {
  if (!num?.toString()) return num;
  let arr = num.toString().split('');
  let hasDecimal = arr.includes('.');
  let decimalIndex = hasDecimal ? arr.indexOf('.') : arr.length;
  let firstNonZeroIndex = 0;
  while (firstNonZeroIndex < decimalIndex && arr[firstNonZeroIndex] === '0') {
    firstNonZeroIndex++;
  }
  arr.splice(0, firstNonZeroIndex);
  return arr.join('');
}

export const arroundNumber = (amount: number) => {
  if (amount != null && amount != undefined) {
    return Math.round(amount * 100) / 100;
  }
  return undefined;
};
